import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FrameworkService } from 'gadoe-framework';
import { RelationshipService } from 'src/app/shared/services/relationship.service';
import { Router } from '@angular/router';
import { IRelationshipMain } from 'src/app/shared/models/relationship';
import { ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { Config } from 'src/app/shared/config';
import { IMessage } from 'src/app/shared/models/common';

@Component({
  selector: 'app-relationshipeditmapping',
  templateUrl: './relationshipeditmapping.component.html',
  styleUrls: ['./relationshipeditmapping.component.css']
})
export class RelationshipeditmappingComponent implements OnInit {
  mcode = '';
  dcode = '';
  cols: any[];
  Acols: any[];
  opened = false;
  mainCode = '';
  selectedval: any;
  msgs: IMessage[] = [];
  columnHeaderName: any;
  mappingTable: IRelationshipMain[] = [];
  availableTable: IRelationshipMain[] = [];
  casheTable: string[] = [];
  // mappingtableSort: IRelationshipMain[] = [];
  mappingList: IRelationshipMain[] = [];
  availableList: IRelationshipMain[] = [];
  public active = false; showPopup: boolean; popupmessage: string;
  @Input() public columnHeaderID: number;
  public fiscalYear: number;
  show: boolean;
  @Input() public mappingcode: number;
  @Input() public fiscalYearConfigID: number;
  @Input() set mcodeValue(value: string) {
    this.mcode = value;

  }
  get mcodeValue(): string {
    return this.mcode;
  }
  @Input() set activeVal(value: boolean) {
    this.active = value;
  }
  get activeVal(): boolean {
    return this.active;
  }

  @Input() set fiscalyear(value: number) {
    this.fiscalYear = value;
  }
  get fiscalyear(): number {
    return this.fiscalYear;
  }
  @Input() set mainCodeValue(value: string) {
    this.mainCode = value;
  }
  get mainCodeValue(): string {
    return this.mainCode;
  }
  @Input() set dcodeValue(value: string) {
    this.dcode = value;
  }
  get dcodeValue(): string {
    return this.dcode;
  }
  @Input() set mappingTableData(value: IRelationshipMain[]) {
    this.showPopup = false;
    this.popupmessage = '';
    this.show = true;
    this.mappingTable = value;
    this.mappingList = [];
  }
  get mappingTableData(): IRelationshipMain[] {
    return this.mappingTable;
  }
  @Input() set availableTableData(value: IRelationshipMain[]) {
    this.availableTable = value;
    this.availableList = [];
  }
  get availableTableData(): IRelationshipMain[] {
    return this.availableTable;
  }
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  constructor(private frmbuilder: FormBuilder,
    private frameworkService: FrameworkService,
    private dataService: RelationshipService, private route: Router) { }

  ngOnInit() {
    this.cols = [
      { field: 'code', header: 'Code' },
      { field: 'name', header: 'Name' }
    ];
  }
  shiftToMapping() {
    const tab: IRelationshipMain[] = [];
    for (let index = 0; index < this.availableList.length; index++) {
      this.mappingTable.push(this.availableList[index]);
      for (let i = 0; i < this.availableTable.length; i++) {
        if (this.availableTable[i].code === this.availableList[index].code) {
          this.availableTable.splice(i, 1);
          break;
        }
      }
    }
    this.show = false;
    this.showPopup = false;
    this.availableList.length = 0;
  }

  shiftToAvailable() {
    const tab: IRelationshipMain[] = [];
    this.showPopup = false;
    for (let index = 0; index < this.mappingList.length; index++) {
       if (this.mappingList[index].startYear === Config.fiscalYear) {
        //  this.showDailogue();

        this.showPopup = true;
        this.show = true;
       this.casheTable.push(this.mappingList[index].code);
      }
    }
    if (this.showPopup === true) {
      this.popupmessage = '!! The Relationship for codes <b>' + this.casheTable.join() +
      ' </b> are created in FY ' + Config.fiscalYear + '. It cannot be ended for the same FY ' +
      Config.fiscalYear + '.';
      this.casheTable = [];
    }
    if (this.showPopup === false) {
      this.show = false;
      for (let index = 0; index < this.mappingList.length; index++) {
        this.availableTable.push(this.mappingList[index]);
        for (let i = 0; i < this.mappingTable.length; i++) {
          if (this.mappingTable[i].code === this.mappingList[index].code) {
            this.mappingTable.splice(i, 1);
            break;
          }
        }
      }
    }
       this.mappingList.length = 0;
  }

  allToAvailable() {
    const tab: IRelationshipMain[] = [];
    this.showPopup = false;
    for (let index = 0; index < this.mappingTable.length; index++) {
      if (this.mappingTable[index].startYear === Config.fiscalYear) {
        //  this.showDailogue();
        this.showPopup = true;
        this.show = true;
       this.casheTable.push(this.mappingTable[index].code);
      }
    }
    if (this.showPopup === true) {
      this.popupmessage = '!! The Relationship for codes <b>' + this.casheTable.join() +
      ' </b> are created in FY ' + Config.fiscalYear + '. It cannot be ended for the same FY ' +
      Config.fiscalYear + '.';
      this.casheTable = [];
    }
    if (this.showPopup === false) {
      this.show = false;
      for (let index = 0; index < this.mappingTable.length; index++) {
        this.availableTable.push(this.mappingTable[index]);
      }
      this.mappingTable = [];
    }   
    this.mappingList.length = 0;
  }

  allToMapping() {
    for (let index = 0; index < this.availableTable.length; index++) {
      this.mappingTable.push(this.availableTable[index]);
    }
    this.availableTable = [];
    this.availableList.length = 0;
    this.show = false;
    this.showPopup = false;
  }

  public saveMapping(e): void {
    e.preventDefault();
    let excludetab: IRelationshipMain[] = [];
    let mappingtab: IRelationshipMain[] = [];
    mappingtab = this.mappingTable;
    excludetab = this.availableTable;


    for (let index = 0; index < excludetab.length; index++) {
      excludetab[index].fiscalYearConfigID = this.fiscalYearConfigID;
      excludetab[index].columnHeaderID = this.columnHeaderID;
      excludetab[index].codeID = this.mappingcode;
    }
    for (let index = 0; index < mappingtab.length; index++) {
      mappingtab[index].fiscalYearConfigID = this.fiscalYearConfigID;
      mappingtab[index].columnHeaderID = this.columnHeaderID;
      mappingtab[index].codeID = this.mappingcode;
    }
    let objinfo = { 'elist': excludetab, 'mlist': mappingtab };
    this.save.emit(objinfo);
    this.frameworkService.showSpinner();
       // this.active = false;
  }

  public onCancel(e): void {
    e.preventDefault();
    this.closeForm();
  }

  private closeForm(): void {
    this.active = false;
    this.cancel.emit();

  }
}
